import { cn } from "@omni/utils/styles";

import { useSearchBoxContext } from "@/components/Search/SearchBar/components/SearchBox/context/searchBox.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const OpenButton = ({ className }: Props) => {
    const { onOpenClick } = useSearchBoxContext();
    const { t } = useGranite();

    return (
        <button
            className={cn(className)}
            type={"button"}
            onClick={onOpenClick}
            tabIndex={-1}
            aria-label={t("accessibility.searchBox.open")}
        >
            <i className={cn("las la-lg la-search")} />
        </button>
    );
};
